export default {
  path: 'square',
  name: 'square',
  component: () => import('@/views/biggie/index.vue'),
  meta: {
    locale: '陪玩广场',
    requiresAuth: true,
    icon: 'icon-user-group',
  },
  children: [
    {
      path: 'biggie-square-list',
      name: 'biggie-square-list',
      component: () => import('@/views/biggie/square/index.vue'),
      meta: {
        locale: '陪玩广场',
        requiresAuth: true,
        roles: ['super', 'admin', 'service', 'treasurer', 'biggie', 'user'],
      },
    },
    {
      path: 'biggie-showcase',
      name: 'biggie-showcase',
      component: () => import('@/views/biggie/showcase/index.vue'),
      meta: {
        locale: '人气陪玩',
        requiresAuth: true,
        roles: ['super', 'admin', 'service', 'treasurer', 'biggie', 'user'],
      },
    },
  ],
};
